import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
	Alert,
} from 'reactstrap';

import { toast } from 'react-toastify';
import { Icons } from '../../../utils/Icons';
import { toSmartTitleCase } from '../../../utils/toSmartTitleCase';

const DeleteParticipantModal = ({
    dataParticipant,
    isOpen,
    handleToggleModal,
	participantsList,
	handleParticipantsList
}) => {
	// const dispatch = useDispatch();

    const [isDeleting, setIsDeleting] = useState(false);

	const participantName =
		dataParticipant?.person?.name ||
		`${dataParticipant?.person?.first_name || ''} ${dataParticipant?.person?.last_name || ''}`.trim() ||
		dataParticipant?.name ||
		'-';

	function handleDelete() {
		const participantIndex = participantsList.findIndex((participant) => {
			const participantId = participant?.id || participant?.person?.id || participant?.person?._id;
			const candidateId = dataParticipant?.id || dataParticipant?.person?.id || dataParticipant?.person?._id;
			return participantId && candidateId
				? participantId === candidateId
				: participant === dataParticipant;
		});

		if (participantIndex >= 0) {
			toast.success(`Participante eliminado exitosamente.`, { autoClose: 3000 });
			const updatedGuideDetailList = participantsList.filter((_, index) => index !== participantIndex);
			handleParticipantsList(updatedGuideDetailList);
        }
        handleToggleModal(!isOpen);
	}


	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handleToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de eliminar un participante!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en
							confirmar.
						</p>
						<p className='small'>
							Participante: {toSmartTitleCase(participantName)}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button className='btn-danger btn-label' onClick={() => handleToggleModal()}><i className='icon-x label-icon'></i> Cancelar</Button>
							<button className='btn btn-label btn-primary' onClick={() => handleDelete()} disabled={isDeleting}>{isDeleting ? (<i className='label-icon'><Spinner size='sm' /></i>) : <i className={`${Icons.check2} label-icon`}></i>} Confirmar</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeleteParticipantModal;
